import { useEffect } from 'react'
import { gsap, ScrollTrigger } from '../utils/gsap'

/**
 * Run GSAP ScrollTrigger setup inside a scoped context with automatic cleanup.
 */
export function useGsapScroll(containerRef, enabled, setup) {
  useEffect(() => {
    if (!enabled || !containerRef.current || typeof setup !== 'function') return undefined

    const ctx = gsap.context(() => {
      setup()
    }, containerRef)

    const refresh = () => ScrollTrigger.refresh()

    const onResize = () => refresh()
    const onLoad = () => refresh()

    window.addEventListener('resize', onResize)
    window.addEventListener('load', onLoad)

    const rafId = requestAnimationFrame(refresh)
    const timeoutId = window.setTimeout(refresh, 120)

    return () => {
      cancelAnimationFrame(rafId)
      window.clearTimeout(timeoutId)
      window.removeEventListener('resize', onResize)
      window.removeEventListener('load', onLoad)
      ctx.revert()
    }
  }, [containerRef, enabled, setup])
}
